import { motion } from "framer-motion";
import { PRICING_CARDS, PRICING_NOTE } from "@/constants/business";

export default function PricingSection() {
  return (
    <section id="tarifs" data-testid="pricing-section" className="py-14 md:py-20 px-4 md:px-8 bg-graylight">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Tarifs</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3 mb-3">
            Un tarif clair, adapté à chaque prestation
          </h2>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
            Chaque demande est différente : le tarif est calculé selon la distance, le volume, les accès, les étages et la manutention nécessaire.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PRICING_CARDS.map((card, i) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
              data-testid={`pricing-card-${i}`}
              className="bg-white rounded-2xl p-6 border border-gray-200"
            >
              <h3 className="font-heading font-bold text-base text-navy mb-2">{card.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{card.text}</p>
            </motion.div>
          ))}
        </div>
        <p className="text-sm font-semibold text-navy mt-8 max-w-2xl" data-testid="pricing-note">
          {PRICING_NOTE}
        </p>
      </div>
    </section>
  );
}
